const stanceConfidence = (stance) => stance?.autoSummary?.confidence || 'needs_human_review';

const stanceNeedsApproval = (stance) => (
  stanceConfidence(stance) !== 'high' && stance?.textApproved !== true
);

const approveStance = (stance) => ({ ...stance, textApproved: true, hasError: false });
const deleteStance = (stance) => ({ ...stance, usefulness: 0, hasError: false });

export { stanceConfidence, stanceNeedsApproval, approveStance, deleteStance };
